// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__dbmGc","col":"Table_col__1gQ__","fulfillmentStatus":"Table_fulfillmentStatus__3FWjI","emailCol":"Table_emailCol__pF9cF"};